import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.small";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { fetchContent, fetchArticlesByTag } from '~/services/editorial';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import TcVars from '~/components/functional/TcVars/EditorialTcVars.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import GlobalNavigationBar from '~/components/molecules/Editorial/Global/GlobalNavigationBar.vue';
import GlobalListArticleCard from '~/components/organisms/Editorial/Global/GlobalListArticleCard.vue';

const GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

export default {
  name: 'Magazine',
  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=3600, public'
  }),
  components: {
    Seo,
    GlobalRichText,
    GlobalNavigationBar,
    GlobalListArticleCard,
    RatingJsonLd,
    TcVars
  },

  asyncData(_ref14) {
    return _asyncToGenerator(function* () {
      let {
        params,
        error,
        store
      } = _ref14;

      try {
        const {
          results: blogs
        } = yield fetchContent(store, {
          type: 'blog'
        });

        if (!blogs.length) {
          throw new Error({
            statusCode: 404,
            message: 'Not Found'
          });
        }

        const [{
          data: blog
        }] = blogs;
        let predicate = null;

        if (params.slug) {
          const {
            label
          } = blog.filters.find(filter => filter.tag === params.slug);
          predicate = {
            tags: [label]
          };
        }

        const {
          results: articles
        } = yield fetchArticlesByTag(store, predicate);
        return {
          blog,
          articles
        };
      } catch (err) {
        error({
          statusCode: 404,
          message: 'Not Found'
        });
        console.log(err);
      }

      return false;
    })();
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  }), {
    selected() {
      return this.$route.params.slug || '';
    },

    currentBlog() {
      var _ref8, _ref9, _ref10;

      if (this.$route.params.slug) {
        var _ref11, _ref12, _ref13;

        const selected = this.blog.filters.find(e => e.tag === this.$route.params.slug);
        return {
          title: (_ref13 = selected) != null ? _ref13.description : _ref13,
          image: {
            small: formatPrismicImage((_ref12 = selected) != null ? (_ref12 = _ref12.image) != null ? (_ref12 = _ref12.small) != null ? _ref12.url : _ref12 : _ref12 : _ref12) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref11 = selected) != null ? (_ref11 = _ref11.image) != null ? (_ref11 = _ref11.large) != null ? _ref11.url : _ref11 : _ref11 : _ref11) || EMPTY_PIXEL
          }
        };
      }

      return {
        title: ((_ref10 = this.blog) != null ? _ref10.title : _ref10) || [],
        image: {
          small: formatPrismicImage((_ref9 = this.blog) != null ? (_ref9 = _ref9.image) != null ? (_ref9 = _ref9.small) != null ? _ref9.url : _ref9 : _ref9 : _ref9) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref8 = this.blog) != null ? (_ref8 = _ref8.image) != null ? (_ref8 = _ref8.large) != null ? _ref8.url : _ref8 : _ref8 : _ref8) || EMPTY_PIXEL
        }
      };
    },

    currentSeo() {
      const seo = this.blog;

      if (this.$route.params.slug) {
        const tag = seo.filters.find(e => e.tag === this.$route.params.slug);
        seo.alternates = tag.alternates ? this.buildAlternates(tag.alternates) : [];

        if (tag.canonical) {
          seo.canonical = tag.canonical;
        }

        if (tag.meta_title) {
          seo.meta_title = tag.meta_title;
        }

        if (tag.meta_description) {
          seo.meta_description = tag.meta_description;
        }
      }

      return seo;
    },

    filters() {
      return this.blog.filters;
    },

    currentArticles() {
      return this.articles.map(e => {
        var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;

        return {
          slug: e.slugs[0],
          tags: ((_ref7 = e) != null ? _ref7.tags : _ref7) || [],
          date: ((_ref6 = e) != null ? (_ref6 = _ref6.data) != null ? _ref6.date : _ref6 : _ref6) || '',
          title: ((_ref5 = e) != null ? (_ref5 = _ref5.data) != null ? (_ref5 = _ref5.main_title) != null ? (_ref5 = _ref5[0]) != null ? _ref5.text : _ref5 : _ref5 : _ref5 : _ref5) || '',
          difficulty: ((_ref4 = e) != null ? (_ref4 = _ref4.data) != null ? _ref4.difficulty : _ref4 : _ref4) || 0,
          readingTime: ((_ref3 = e) != null ? (_ref3 = _ref3.data) != null ? _ref3.reading_time : _ref3 : _ref3) || 0,
          image: {
            small: formatPrismicImage((_ref2 = e) != null ? (_ref2 = _ref2.data) != null ? (_ref2 = _ref2.image) != null ? (_ref2 = _ref2.small) != null ? _ref2.url : _ref2 : _ref2 : _ref2 : _ref2) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref = e) != null ? (_ref = _ref.data) != null ? (_ref = _ref.image) != null ? (_ref = _ref.large) != null ? _ref.url : _ref : _ref : _ref : _ref) || EMPTY_PIXEL
          }
        };
      });
    },

    tcVars() {
      return this.blog ? _objectSpread({}, this.blog, {
        env_template: 'Landing Page'
      }) : {};
    }

  }),
  methods: {
    buildAlternates(arg) {
      return arg.split(',').map(e => {
        const hreflang = e.split(':')[0];
        const market = hreflang.split('-')[1].toUpperCase();
        const language = hreflang.split('-')[0];
        const slug = e.split(':')[1];
        return {
          url: {
            url: "".concat(this.baseURL, "/").concat(market, "/").concat(language, "/e/magazine/").concat(slug)
          },
          hreflang
        };
      });
    },

    navigateTo(slug) {
      return {
        params: {
          slug
        },
        hash: '#tabs'
      };
    },

    articlesList(slug) {
      var _this = this;

      return _asyncToGenerator(function* () {
        const filter = _this.blog.filters.find(e => e.tag === slug || '');

        if (filter) {
          const {
            results: articles
          } = yield fetchArticlesByTag(_this.$store, {
            tags: [filter.label]
          });
          _this.articles = articles;
        }
      })();
    }

  }
};